import { showToast } from "../../helpers/utils/Utils";
import { tgxApi } from "../../app/tgxApi";
import { handleQueryError } from "../../helpers/utils/RtkQueryUtils";

const loginPageApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        loginUser: build.mutation({
            query: (request) => {
                const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.replaceAll('/', '&');
                return {
                    url: `/ajax/authenticate/${timeZone}`,
                    method: "POST",
                    body: request,
                };
            },
            async onQueryStarted(_, { queryFulfilled }) {
                try {
                    const res = await queryFulfilled;
                    const result = res?.data;

                    localStorage.setItem('user', 'loggedIn');
                    localStorage.setItem("daysToExpirePassword", JSON.stringify(result?.daysToExpirePassword));
                    const token = result?.customAuthTokenDTO?.token;
                    if (token) {
                        localStorage.setItem('authToken', token);
                    } else {
                        console.warn("Token not found in the response.");
                    }

                    if (result?.customAuthTokenDTO?.isUserHaveTeam !== null) {
                        localStorage.setItem(
                            "isUserHaveTeam",
                            JSON.stringify(result?.customAuthTokenDTO?.userHaveTeam)
                        );
                    }

                    localStorage.setItem(
                        "isUserManager",
                        JSON.stringify(result?.customAuthTokenDTO?.isUserManager)
                    );
                } catch (error: any) {
                    showToast(error?.error?.data?.message || "Login failed", "error");
                    localStorage.clear();
                }
            },
        }),

        baseUrl: build.query({
            query: (url) => {
                return {
                    url: `/ajax/base-url`,
                    method: 'GET',
                    headers: {
                        'X-Tenant-Url': url
                    }
                };
            },
            providesTags: ["baseUrl"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled);
            },
        }),

    })
})
export const {
    useLoginUserMutation,
    useBaseUrlQuery
} = loginPageApi;